import { store } from '../redux/store';
import { createPublicLog } from '../redux/reducers/publicSlice';
import { LogLevel } from '../models/log.model';

export class Logger {
    static log(level: LogLevel, message: string, metadata?: Record<string, any>) {
        store.dispatch(createPublicLog({
            level,
            message,
            metadata,
            source: 'client',
            timestamp: new Date()
        } as any));
    }

    static info(message: string, metadata?: Record<string, any>) {
        this.log(LogLevel.INFO, message, metadata);
    }

    static warning(message: string, metadata?: Record<string, any>) {
        this.log(LogLevel.WARNING, message, metadata);
    }

    static error(message: string, metadata?: Record<string, any>) {
        this.log(LogLevel.ERROR, message, metadata);
    }

    static debug(message: string, metadata?: Record<string, any>) {
        this.log(LogLevel.DEBUG, message, metadata);
    }
} 